import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';


@Component({
  templateUrl: './animation-home.component.html',
  styleUrls: ['./animation-home.component.scss']
})

export class RenaultAnimationHomeComponent implements OnInit {

  userOnlyAdmin = false;

  constructor(private userService: UserService
  ) { }



  ngOnInit(): void {
    this.userService.getUserData().subscribe(resp => {
      if(resp == null) return;
      if (resp.RolesListString.some(x => x == "Administrador")) {
        this.userOnlyAdmin = true;
      }
    });
  }


}
